import axios from 'axios'

// const api_endpoint = 'http://127.0.0.1:5001'
// const api_endpoint = 'https://staging.enterprise.api.docmasweetspot.ca'
const api_endpoint = 'https://fn6mi7qqjd.execute-api.us-east-2.amazonaws.com/dev'
// const api_endpoint = 'https://d6itaje8h6.execute-api.us-east-2.amazonaws.com/prod'

function publish_report(token, payload){
    let api_url = api_endpoint + '/ort/reporting/publish_report';
    return axios_post_call(api_url, payload, token);
}

function create_report_folder(token, payload){
    let api_url = api_endpoint + '/ort/reporting/create_report_folder';
    return axios_post_call(api_url, payload, token);
}

function get_reports(token, payload){
    let api_url = api_endpoint + '/ort/reporting/get_reports';
    return axios_post_call(api_url, payload, token);
}

function get_filters(token, payload){
    let api_url = api_endpoint + '/ort/reporting/filter_values';
    return axios_post_call(api_url, payload, token);
}

function update_report(token, payload){
    let api_url = api_endpoint + '/ort/reporting/update_report';
    return axios_post_call(api_url, payload, token);
}

function delete_report(token, payload){
    let api_url = api_endpoint + '/ort/reporting/delete_report';
    return axios_post_call(api_url, payload, token);
}

function move_reports(token, payload){
    let api_url = api_endpoint + '/ort/reporting/move_reports';
    return axios_post_call(api_url, payload, token);
}

function fetch_report_data(token, payload){
    let api_url = api_endpoint + '/ort/reporting/fetch_report_data';
    return axios_post_call(api_url, payload, token);
}

function fetch_report_abv(token, payload){
    let api_url = api_endpoint + '/ort/reporting/fetch_report_abv';
    return axios_post_call(api_url, payload, token);
}

function update_report_abv(token, payload){
    let api_url = api_endpoint + '/ort/reporting/update_report_abv';
    return axios_post_call(api_url, payload, token);
}

function optimize_report(token, payload){
    let api_url = api_endpoint + '/ort/reporting/optimize_report';
    return axios_post_call(api_url, payload, token);
}



/*
Base Caller functions
*/
function axios_post_call(api_url,data,token){
    return new Promise(function(resolve,reject){
        axios.post(api_url, data, {headers: {Authorization: `Bearer ${token}`}}).then((res)=>{
            if(res.status == 200){
                resolve(res.data);
            }
            else{
                reject();
            }
        }).catch((e)=>{
            reject(api_url+e);
        })
    })
}

export default {
    create_report_folder,
    publish_report,
    get_reports,
    update_report,
    delete_report,
    move_reports,
    fetch_report_data,
    get_filters,
    fetch_report_abv,
    update_report_abv,
    optimize_report
}
